import { CIMSTabs } from 'components/CIMSTabs'
import { RolesTable } from './components/RolesTable'
import TemplatesTable from './components/TemplatesTable'

const Tab = { Roles: 'Roles', Templates: 'Templates' } as const

const RolesTabs: React.VFC = () => (
  <CIMSTabs
    initialTab={Tab.Roles}
    tabs={[
      {
        label: Tab.Roles,
        key: Tab.Roles,
        component: <RolesTable />,
      },
      {
        label: Tab.Templates,
        key: Tab.Templates,
        component: <TemplatesTable />,
      },
    ]}
  />
)

export default RolesTabs
